export default __webpack_public_path__ + "static/Image083-33a68119ccb355464eec38411bc55bed.webp";